// extracted by mini-css-extract-plugin
export default {"scrollable":"CaseLaws_scrollable__RlKgy","backdrop":"CaseLaws_backdrop__hngW4"};